/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_TEAMS(state, teams) {
        state.teams = teams
    },
    //SET_ROUNDTABLETOPICS(state, roundtabletopics) {
    //    state.roundtabletopics = roundtabletopics
    //},
    REMOVE_RECORD(state, userId) {
        const Index = state.teams.findIndex((u) => u.userId === userId)
        state.teams.splice(Index, 1)
    }
}